<script>
	module.exports = {
		props: {
			article: {
				type: Object,
				required: true
			},
			loggedIn: {
				required: true
			},
			myList: {
				required: true
			},
			toggleOnList: {
				required: true
			},
			onProductLinkClick: {
				type: Function,
				default: function () {}
			},
			debug: {
				default: false
			}
		},
		modelData: ['gcAddon'],
		components: {
			'article-result-content': require('components/article-result-content.vue').default,
			'add-to-my-list-button': require('components/add-to-my-list-button.vue').default
		},
		computed: {
			showNewIndicator() {
				const month = 30 * 24 * 60 * 60 * 1000;
				const timePublished = Date.now() - new Date(this.article.firstPublished).getTime();

				return timePublished < month;
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	div.article-search-result {
		position: relative;

		.new-indicator {
			position: absolute;
			top: 1.05rem;
			left: -0.95rem;
			padding: 0 0.535rem;
			font-size: 12px;
			line-height: 1.167;
			letter-spacing: 0.2px;
			transform: rotate(90deg);
			text-transform: uppercase;
			background-color: $c-white;
			color: $c-grape-main;
			border: 1px solid $c-grape-main;
			border-radius: 8px 8px 0 0;
			pointer-events: none;
		}

		> .article {
			.article-header .add-to-my-list-button {
				margin-left: 0.5rem;
				.button {
					margin-left: 0rem;
					float: none;
				}
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		div.article-search-result {
			.new-indicator {
				top: 3rem;
			}

			> .article {
				.article-header .add-to-my-list-button {
					margin-left: 0;
					min-width: 6rem;
				}
			}

			.article-result-content:not(.-has-summary) {
				.article-meta {
					max-width: calc(100% - 5rem);
				}
			}
		}
	}
</style>
<template>
	<div class="article-search-result">
		<div
			v-if="showNewIndicator"
			class="new-indicator">
			New <span class="hidden-visually">article</span>
		</div>
		<article-result-content
			:article="article"
			:on-product-link-click="onProductLinkClick"
			:debug="debug">
			<add-to-my-list-button
				slot="title-tools"
				v-if="!gcAddon"
				:toggle-on-list="toggleOnList"
				:article="article"
				:my-list="myList"
				:logged-in="loggedIn">
			</add-to-my-list-button>
		</article-result-content>
	</div>
</template>
